import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// src/utils/cn.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=chunk-FFX3LZW7.js.map
//# sourceMappingURL=chunk-FFX3LZW7.js.map